import { Button, Card, Checkbox, Col, Form, Input, Row, Select, Space } from "antd";
import { CheckboxChangeEvent } from "antd/es/checkbox";
import { useEffect, useState } from "react";

const payloadTypes = [
    { label: 'Bar-separated Values (BSV)', value: 'BSV' },
    { label: 'Comma-separated Values (CSV)', value: 'CSV' },
    { label: 'Tab-separated Values (TSV)', value: 'TSV' },
    { label: 'Excel', value: 'EXCEL' },
    { label: 'JSON', value: 'JSON' },
    { label: 'XML', value: 'XML' },
    { label: 'PDF', value: 'PDF' },
    { label: 'Word', value: 'WORD' },
]

const ClientConfiguration = ({show, client, onClose, onNext}: any) => {

    const [transmit, setTransmit] = useState(false);
    const [form] = Form.useForm();
    const payloadType = Form.useWatch('payloadType', form);
    const includeXmlTag = Form.useWatch('includeXmlTag', form);

    useEffect(() => {
        form.setFieldsValue(client);
        setTransmit(client?.transmit);
    }, [client]);
    
    const requiredRule = (isRequired: boolean, message: string) => {
        return {
          required: isRequired,
          message: message,
        }
    }

    const onFinish = (values: any) => {
        const data = {...client, ...values};
        onNext(data);
    }

    const toggleTransmission = (e: CheckboxChangeEvent) => {
        setTransmit(e.target.checked);
    }

    return <Form 
        form={form}
        className="clients-page-form"
        onFinish={onFinish}
        style={{overflow: 'hidden', height: show ? 'auto' : '0rem'}}
        >
  
        <h2>Client and Service Configuration</h2>
        
        <h3>General Settings</h3>
        <label>Name *</label>
        <Form.Item
            name="name"
            rules={[
            requiredRule(true, "Name is required.")
            ]}
        >
            <Input />
        </Form.Item>
    
        <label>Client Code *</label>
        <Form.Item
            name="clientCode"
            rules={[
            requiredRule(true, "Client code is required.")
            ]}
        >
            <Input />
        </Form.Item>
    
        <h3>Service Settings</h3>
        <Row gutter={64}>
            <Col span={11}>
                <Form.Item
                    name="transmit"
                    valuePropName="checked">
                    <Checkbox onChange={toggleTransmission}>Enable transmission on post</Checkbox>
                </Form.Item>
            </Col>
            <Col span={13}>
                <Form.Item
                    name="oneItemPerOutput"
                    valuePropName="checked">
                    <Checkbox>One Item Per Output</Checkbox>
                </Form.Item>
            </Col>
        </Row>
        <Row gutter={64}>    
            <Col span={11}>
                <Form.Item
                    name="transformEnabled"
                    valuePropName="checked">
                    <Checkbox>Transform by script enabled</Checkbox>
                </Form.Item>
            </Col>
            <Col span={13}>
                <Form.Item
                    name="includeAttachments"
                    valuePropName="checked">
                    <Checkbox>Include attachments in transmission</Checkbox>
                </Form.Item>
            </Col>
        </Row>
        
        <label>Payload Type *</label>
        <Form.Item
            name="payloadType"
            rules={[
                requiredRule(true, "Payload Type is required.")
            ]}
        >
            <Select options={payloadTypes} />
        </Form.Item>

        {payloadType === 'XML' &&
            <Card bordered={false} styles={{body: {padding: 0}}}>
                <Row gutter={64}>
                    <Col span={11}>
                        <Form.Item
                            name="includeXmlTag"
                            valuePropName="checked">
                            <Checkbox>Include XML Header</Checkbox>
                        </Form.Item>
                    </Col>
                    <Col span={13}>
                        <Space align="center">
                            <label>Encoding</label>
                            <Form.Item name="xmlHeaderEncoding" className="inline-field">
                                <Input disabled={!includeXmlTag} />
                            </Form.Item>
                        </Space>
                    </Col>
                </Row>
            </Card>
        }

        <h3>Scheduling</h3>
        <label>Cron Schedule</label>
        <Form.Item
            name="cronSchedule"
        >
        <Input/>
        </Form.Item>

        <Space direction="horizontal" align="end" style={{marginTop: '2rem', width: '100%', justifyContent: 'flex-end'}}>
            <Button type="default" key="cancel" onClick={onClose}>Cancel</Button>
            <Button type="primary" htmlType="submit">Proceed</Button>
        </Space>
    </Form>
}

export default ClientConfiguration;